// extracted by mini-css-extract-plugin
module.exports = {"container":"peopleDrawer_container__1cWhw","person":"peopleDrawer_person__2zQwF","all":"peopleDrawer_all__lQ7IN","active":"peopleDrawer_active__psRwO"};